import { LoadableLazy } from '@confluence/loadable';

export const SplitPageResultLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SplitPageResult" */ '../src/components/SplitPageResult.tsx'
			)
		).SplitPageResult,
});
